export default "__VITE_ASSET__CiFX5K1P__"